import { useEffect, useState } from "react";

import CardSkeleton from "components/Skeletons/Card.Skeleton";
import { Grid } from "@mui/material";
import { PORTFOLIO_INVESTMENT_TABLE_HEADERS } from "../constants";
import PortfolioInvestmentBox from "./Components/PortfolioInvestmentBox";
import ProfitAndLossBox from "./Components/ProfitAndLossBox";
import Table from "components/Table";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import WrapperDepositWithdraw from "./Components/WrapperDepositWithdraw";
import WrapperInventory from "./Components/WrapperInventory";
import WrapperInventoryAvailableNow from "./Components/WrapperInventoryAvailableNow";
import WrapperValueBalance from "./Components/WrapperValueBalance";
import { formatDateToJalali } from "utils/helpers/time";
import { getPortfolioInvestmentList } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import useIsMobileView from "hooks/useIsMobileView";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo } from "react";

function PortfolioInvestmentTable() {
  const dispatch = useDispatch();
  const isMobileView = useIsMobileView();

  const portfolioChartForm = useSelector((state) => state.portfolio?.portfolioChartForm?.data);
  const portfolioInvestmentList = useSelector(
    (state) => state.portfolio.portfolioInvestmentList?.data
  );

  const defaultPortfolioChartForm = useMemo(() => portfolioChartForm?.lisPortfolioChartFormDetail?.find((l) => l?.id === portfolioChartForm?.portfolioChartFormDetailId), [portfolioChartForm])

  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const portfolioDate = +searchParams.get("portfolioDate") || 0;
  const startDate = searchParams.get("startDate") || "";
  const portfolioTab = +searchParams.get("portfolioTab") || defaultPortfolioChartForm?.portfolioId || 1;
  const basketTab = +searchParams.get("basketTab") || "";

  const formattedDataList = portfolioInvestmentList?.lisPortfolio?.map(
    (data) => {
      return {
        data: data,
        valueBalance: <WrapperValueBalance data={data} />,
        inventory: <WrapperInventory data={data} />,
        depositWithdraw: <WrapperDepositWithdraw data={data} />,
        inventoryAvailableNow: <WrapperInventoryAvailableNow data={data} />,
      };
    }
  );

  const getPortfolioDetails = async () => {
    setLoading(true);
    await dispatch(
      getPortfolioInvestmentList({
        portfolioId: portfolioTab,
        basketId: basketTab,
        dateTypeId: portfolioDate,
        startDate: formatDateToJalali(startDate),
      })
    );
    setLoading(false);
  };

  useEffect(() => {
    getPortfolioDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioDate, startDate, basketTab]);

  return (
    <Grid container mt={2}>
      <Grid item xs={12}>
        {!loading ? <ProfitAndLossBox /> : <CardSkeleton heightSize={172} />}
      </Grid>

      <Grid item xs={12}>
        {isMobileView ? (
          <Grid container spacing={2}>
            {!loading ? (
              <>
                {portfolioInvestmentList?.lisPortfolio?.map((data) => (
                  <Grid item xs={12}>
                    <PortfolioInvestmentBox portfolioInvestmentItem={data} />
                  </Grid>
                ))}
              </>
            ) : (
              <Grid item xs={12}>
                <CardSkeleton heightSize={170} />
                <CardSkeleton heightSize={170} />
                <CardSkeleton heightSize={170} />
              </Grid>
            )}
          </Grid>
        ) : (
          <>
            {!loading ? (
              <Table
                headers={PORTFOLIO_INVESTMENT_TABLE_HEADERS}
                items={formattedDataList}
              />
            ) : (
              <TableSkeleton />
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
}

export default PortfolioInvestmentTable;
